<template>
  <div class="wdw-forum-create-thought" :class="'topic-' + topicid">
    <template v-if="!topic">
      <loading loadingMessage="Formular wird geladen..." />
    </template>

    <template v-else>
      <template v-if="showForm">
        <wdw-dynbox>
          <thought-form
            :topic="topic"
            @feedback-thought="onFeedbackFromCreate"
            @cancel-thought-form="cancelThoughtForm"
            @open-thought="openConfirmDialog"
            labelTitle="Überschrift des Themas"
            labelDescription="Beschreibung"
            :suggestionsConfig="{ disableOpening: false, hideVoting: true, hideComments: true, disableEditing: true }"
          />
        </wdw-dynbox>
        <Dialog header="Eingabe abbrechen?" v-model:visible="showConfirmDialog" contentClass="wdw-widgets">
          Möchten Sie die Eingabe abbrechen um das ausgewählte Thema zu öffnen?

          <template #footer>
            <div class="wdw-widgets">
              <button class="btn btn-primary" @click="openThought">Ja, Thema öffnen</button>
              <button class="btn btn-default" @click="hideDialog">Abbrechen</button>
            </div>
          </template>
        </Dialog>
      </template>
      <template v-else>
        <p>Fehler, bitte Loggen Sie sich zunächst ein</p>
      </template>
    </template>
  </div>
</template>

<script>
import { onBeforeMount, ref, computed, toRef } from 'vue';

// stores
import { projectStore } from '@/store/project-store';

// components
import Dialog from 'primevue/dialog';
import Loading from '@/components/general/Loading.vue';
import ThoughtForm from '@/components/discuss/thought/Form.vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';

// composables
import useTopicConfig from '@/composables/topic/useTopicConfig';

export default {
  name: 'forum-create-thought',
  props: {
    topicid: {
      type: Number,
      required: true,
    },
  },
  emits: ['show-thought', 'show-topic', 'push-message', 'clear-messages', 'show-topics'],

  setup(props, context) {
    const topicid = toRef(props, 'topicid');
    const topic = ref(null);
    const loadingTopic = ref(true);
    const showConfirmDialog = ref(false);
    const suggestionThoughtIdTemp = ref(null);

    const { canCreateThought } = useTopicConfig();

    //
    //-----------------COMPUTED------------------
    //

    const showForm = computed(() => {
      return topic.value && canCreateThought(topic.value);
    });

    //
    //-----------------METHODS------------------
    //
    function initTopic() {
      // fetch topic
      projectStore
        .fetchTopic(topicid.value)
        .then(resp => {
          // check if we're allowed to access topic, in case of restricted_access
          if (resp.restrict_public_access == 0 || resp.restricted_access == 'allowed') {
            loadingTopic.value = false;
            topic.value = resp;
          } else {
            // not allowed, reroute back to topics
            context.emit('show-topics');
          }
        })
        .catch(err => {
          console.log(err);
          // error, reroute back to topics
          context.emit('show-topics');
        });
    }
    function cancelThoughtForm() {
      context.emit('show-topic', {
        topicid: props.topicid,
        name: topic.value.title,
      });
    }
    function onFeedbackFromCreate(feedback) {
      //new thought was created, go back to list view
      if (feedback.thought && feedback.thought.status === 'show') {
        context.emit('show-thought', {
          thoughtid: feedback.thought.id,
          name: feedback.thought.title,
        });
      } else {
        context.emit('show-topic', {
          topicid: props.topicid,
          name: topic.value.title,
        });
      }
      context.emit('push-message', {
        severity: feedback.type,
        content: feedback.message,
      });
    }
    function hideDialog() {
      showConfirmDialog.value = false;
      suggestionThoughtIdTemp.value = null;
    }
    function openConfirmDialog(thoughtid) {
      suggestionThoughtIdTemp.value = thoughtid;
      showConfirmDialog.value = true;
    }
    function openThought() {
      if (suggestionThoughtIdTemp.value) {
        context.emit('show-thought', {
          thoughtid: suggestionThoughtIdTemp.value,
        });
      } else {
        context.emit('push-message', {
          severity: 'error',
          content: 'Beim Öffnen des Themas ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
        });
      }
      hideDialog();
    }

    // initialization
    onBeforeMount(() => {
      // reset any messages on new thought
      context.emit('clear-messages');
      initTopic();
    });

    return {
      // REFS
      topic,
      showConfirmDialog,

      // COMPUTED
      showForm,

      // METHODS
      cancelThoughtForm,
      onFeedbackFromCreate,
      openThought,
      hideDialog,
      openConfirmDialog,
    };
  },

  components: {
    Loading,
    ThoughtForm,
    WdwDynbox,
    Dialog,
  },
};
</script>
